// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"35ea9412","977":"247e84ca"}[chunkId] + ".chunk.js";
};